import { css } from '@emotion/core'

// Modal の customCss はスプレッドで合成されるため、css() ではなくプレーンなオブジェクトで返す
export const centeredModalStyle = (width: number) => ({
  width,
  height: 'unset',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
})

export const modalFooterRightStyle = css({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
})
